import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import { YuantaDRIcon, ContactUsIcon, ContactUsFillIcon, CaretLeftDarkIcon, CaretRightDarkIcon, HambergerIcon } from './Icons';
import { Helmet } from 'react-helmet';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            showFixedNav: false,
            banners: []
        };

        this.handleScroll = this.handleScroll.bind(this);
        this.nextBanner = this.nextBanner.bind(this);
        this.previousBanner = this.previousBanner.bind(this);
    }

    async fetchBanners() {
        var url = 'api/Content/getslidingbanner';

        const response = await fetch(url);
        const data = await response.json();
        this.setState({ banners: data !== null ? data : [], activeBanner: 0 });
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, true);
        window.setInterval(this.nextBanner, 8000);
        if (this.props.isIndex === true) {
            this.fetchBanners();
        }
    }

    componentDidUpdate(prevProp) {
        if (this.props.isIndex !== prevProp.isIndex && this.props.isIndex === true) {
            this.fetchBanners();
        }

        if (this.props.pathname !== prevProp.pathname) {
            this.setState({ collapsed: true });
        }

    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
        window.clearInterval(this.nextBanner);
    }

    handleScroll(event) {
        if (window.scrollY >= 300) {
            this.setState({ showFixedNav: true });
        } else {
            this.setState({ showFixedNav: false });
        }
    }

    nextBanner() {
        var { activeBanner, banners } = this.state;

        if (activeBanner < banners.length - 1) {
            activeBanner += 1;
        } else {
            activeBanner = 0;
        }

        this.setState({ activeBanner });
    }

    previousBanner() {
        var { activeBanner, banners } = this.state;

        if (activeBanner > 0) {
            activeBanner -= 1;
        } else {
            activeBanner = banners.length - 1;
        }

        this.setState({ activeBanner });
    }

    toggleNavbar(e) {
        e.preventDefault();
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    goTo(symbol) {
        try {
            window.location.href = 'DrDetail/' + symbol;
        } catch (error) {
            window.location.href = 'Contents';
        }
    }
    goToUrl(urlLink) {
        try {
            if (urlLink !== "" && urlLink.length > 0) {
                window.open(urlLink);
            }
        } catch (error) {

        }
    }
    render() {
        var { showFixedNav, banners, activeBanner } = this.state;
        var { isIndex } = this.props;
        var backgroundImage = `${banners && banners.length > 0 ? `url(${banners[activeBanner].backgroundPictureUrl})` : ''}`;
        return (
            <header className={isIndex ? "main-banner" : "main-banner hide-banner"} style={{ backgroundImage }}>

                {(isIndex && banners.length > 0) && <Helmet>
                    <title>DR19 Yuanta</title>
                    <meta property="og:title" content="DR19 Yuanta" />
                    <meta property="og:description"
                        content="ลงทุนต่างประเทศ บนกระดานหุ้นไทย ตราสารที่ถูกออกแบบมาเพื่อให้นักลงทุนไทยสามารถซื้อขายหุ้นหรือ ETF ในต่างประเทศได้ สะดวกสบายเพราะมีขั้นต่ำเพียง 1 หุ้น DR" />
                    <meta property="og:type" content="video.movie" />
                    <meta property="og:image" content={banners[0].backgroundPictureUrl} />
                </Helmet>}
                <Navbar className={`navbar-expand-md navbar-toggleable-md ng-white mb-3 ${showFixedNav === true || isIndex !== true ? "yt-fixed-nav" : "yt-white-nav"}`} container light fixed="top">
                    <NavbarBrand tag={Link} to="/">
                        <YuantaDRIcon />
                    </NavbarBrand>
                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2" >
                        <HambergerIcon />
                    </NavbarToggler>
                    <Collapse className="d-md-inline-flex flex-md-row-reverse" isOpen={!this.state.collapsed} navbar>
                        <ul className="navbar-nav flex-grow">
                            <NavItem>
                                <NavLink tag={Link} to="/Contents">ข่าวสาร / บทวิเคราะห์</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} to="/Content/Pages/what-is-dr">DR คืออะไร</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} to="/contact">
                                    <ContactUsIcon />
                                    ติดต่อเรา</NavLink>
                            </NavItem>
                        </ul>
                    </Collapse>
                </Navbar>
                {isIndex && banners.length > 0 && <Container className='main-banner-detial-container'>
                    <div className='main-banner-carets'>
                        <div>
                            <button onClick={this.previousBanner}><CaretLeftDarkIcon /></button>
                            <button onClick={this.nextBanner}><CaretRightDarkIcon /></button>
                        </div>
                    </div>
                    {banners.map((banner, i) => <div key={`main-banner-${i}`} className={`main-banner-detial ${activeBanner === i ? 'active' : 'inactive'}`}>
                        <h1>{banner.topicText}</h1>
                        <p className='sub-title2'>{banner.descriptionText}</p>
                        {(banners[activeBanner].urlLink !== null && banners[activeBanner].urlLink !== "") ?
                            <>
                                <button className='button-main' style={{ marginRight: '10px' }} onClick={() => this.goToUrl(banners[activeBanner].urlLink)}>
                                    {(banners[activeBanner].urlLinkText !== null && banners[activeBanner].urlLinkText !== "") ? banners[activeBanner].urlLinkText : "Click"}
                                </button>
                            </> : <></>}
                        <button className='button-secondary' onClick={() => this.goTo(banners[activeBanner].symbol)}>อ่านต่อ</button>
                    </div>)}
                </Container>}
            </header>
        );
    }
}
